import { useContext } from "react";
import { GenericSimulatorContext } from "../context";

const useGenericSimulator = () => {
    const context = useContext(GenericSimulatorContext);
    if (context === undefined) {
        throw new Error('useGenericSimulator must be used within a GenericSimulatorProvider');
    }
    return context;
};

export default useGenericSimulator;
